import {connect} from 'react-redux';

import {globalWindow} from '../../../../../../libs/shared/core/src/helpers/browser/browserHelpers';
import {ContactSourcesEnum} from '../../../../../../libs/shared/core/src/models/api/contactModel';
import {isGlobalAdmin} from '../../../../../../libs/shared/core/src/models/helpers/accessModelHelpers';
import {getUserRoleByNamespace} from '../../../../../../libs/shared/core/src/store/data/access/commonAccessSelectors';
import {createSelector, makeMapStateToProps} from '../../../../../../srcCommon/helpers/reselectHelpers';
import {isTeamAdmin} from '../../../../../helpers/models/accessHelpers';
import {ActivitySourceContactModel} from '../../../../../models/api/activitySourceModel';
import {makeSettingsUrlFromPathId} from '../../../../../settings/menu/settingsHelpers';
import {AppState} from '../../../../../store/appState';
import {Dispatch} from '../../../../../store/appStore';
import {getChannels} from '../../../../../store/data/channels/channelsSelectors';
import {getCompanyUrl} from '../../../../../store/data/company/companySelectors';
import {toggleLastSuppressionListsRemovalAction} from '../../../../../store/data/localPreferences/localPreferencesActions';
import {navigateToLinkAction} from '../../../../../store/stateless/navigationActions';
import {BasicActivityErrorViewer} from './basicActivityErrorViewer';

/*
 * Props.
 */

interface BasicActivityErrorViewerContainerProps {
  activitySource: ActivitySourceContactModel;
  namespace: string;
}

/*
 * Redux.
 */

function getNamespace(_state: AppState, props: BasicActivityErrorViewerContainerProps) {
  return props.namespace;
}

function getActivitySource(_state: AppState, props: BasicActivityErrorViewerContainerProps) {
  return props.activitySource;
}

function makeGetShouldShowSuppressionListCta() {
  return createSelector(
    [getUserRoleByNamespace, getNamespace, getActivitySource, getChannels],
    (roleByNamespace, namespace, activitySource, channels) => {
      // If the contact source isn't of type email, nothing to do.
      if (activitySource.contact.source !== ContactSourcesEnum.EMAIL) {
        return false;
      }

      // If we don't have a channel ID, nothing to do.
      if (!activitySource.senderChannelId) {
        return false;
      }

      // If no channel can be found, nothing to do.
      if (!channels[activitySource.senderChannelId]) {
        return false;
      }

      // Check if our user is a global admin or a team admin of the current namespace.
      return isGlobalAdmin(roleByNamespace) || isTeamAdmin(namespace, roleByNamespace);
    },
  );
}

const mapStateToProps = makeMapStateToProps<BasicActivityErrorViewerContainerProps>()(() => ({
  shouldShowSuppressionListCTA: makeGetShouldShowSuppressionListCta(),
  companyUrl: getCompanyUrl,
}));

function mapDispatchToProps(dispatch: Dispatch, ownProps: BasicActivityErrorViewerContainerProps) {
  return {
    onSuppressionListsRemoval: () => {
      dispatch(toggleLastSuppressionListsRemovalAction(ownProps.activitySource.name));

      // Remove suppression lists removal banner after a delay.
      const bannerTimeout = 15 * 1000;
      globalWindow.setInstrumentedTimeout(
        () => dispatch(toggleLastSuppressionListsRemovalAction(ownProps.activitySource.name, true)),
        bannerTimeout,
      );
    },
    onDeliverabilityClick: () => {
      const deliverabilityPath = makeSettingsUrlFromPathId('settings.deliverability');
      dispatch(navigateToLinkAction(deliverabilityPath));
    },
  };
}

export const BasicActivityErrorViewerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BasicActivityErrorViewer);
